import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { fetchUserProfile } from '../../store/userProfile/actionCreators'
import UserAccountPage from '../../common/pages/user-account-page/UserAccountPage';
import LoanList from '../../components/LoanList/LoanList';

import './loans.less';

const LoansPage = ({
  match: {
    params: {
      userId
    }
  },
  user: {
    token,
  },
  userProfile: {
    isUserProfileRequested,
    loans
  },
  fetchUserProfile
}) => {
  useEffect(() => {
    fetchUserProfile(token, userId ? userId : null);
  }, [token, userId]);

  return (
    <UserAccountPage
      userId={userId}
      isLoading={isUserProfileRequested}
    >
      <div className="loans__wrapper">
        <div className="loans__banner">
          <h1>New loan tools are coming soon!</h1>
          <p>We’re upgrading our systems to make it easier to access and manage your loan online.</p>
          <p>Until those tools are available, please contact our Loans team for any information or assistance related to your loan.</p>
          <p className="contacts">
            <a href="tel:8009335502">800.933.5502</a>
            <a href="mailto:loans@texasmethodistfoundation.org">loans@texasmethodistfoundation.org</a>
          </p>
        </div>
      </div>
    </UserAccountPage>
  );
}

export default connect(
  ({ user, userProfile }) => ({ user, userProfile }),
  { fetchUserProfile }
)(LoansPage);
